import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromTopbar from "../../reducers/topbar/topbar.reducer";
import { selectLoggedInUserRoles, selectActiveUser } from "../user/user.selectors";

const ISSUE_TRACKER_MENU_KEY = 'Issue Tracker';
export const selectTopbarState = createFeatureSelector<fromTopbar.State>(
  fromTopbar.topbarFeatureKey
);

export const selectMenuItems = createSelector(
  selectTopbarState,
  (state: fromTopbar.State) => state.menuItems
);
export const selectPageLabel = createSelector(
  selectTopbarState,
  (state: fromTopbar.State) => state.pageLabel
);
export const selectCurrentIcon = createSelector(
  selectTopbarState,
  (state: fromTopbar.State) => state.currentIcon
);

export const selectVisibleMenuItems = createSelector(
  selectMenuItems,
  selectLoggedInUserRoles,
  selectActiveUser,
  (menuItems, userRoles, user) => {
    return menuItems.filter((item) => {
      if (!item.requiredRoles || item.requiredRoles.length === 0) {
        return true;
      }

      return item.requiredRoles.some((role) =>
        userRoles.includes(role)
      );
    });
  }
);